module.exports = __webpack_public_path__ + "static/media/StageDP.f0562a14.jpg";